import React, { type JSX } from 'react'

import { SettingsRow } from '../Settings'

import { Switch } from 'shared/components/Switch'

type DataExportToggleProps = {
  client: any
  isDataDownloadEnabled?: boolean
  enable: () => void
  disable: () => void
}

export function DataExportToggle({
  client,
  isDataDownloadEnabled,
  enable,
  disable,
}: DataExportToggleProps): JSX.Element {
  return (
    <SettingsRow label={`Allow Data Exports for ”${client.firstName} ${client.lastName}”`}>
      <span data-testid="client-data-export-toggle">
        <Switch
          defaultChecked={isDataDownloadEnabled}
          name="Data Export Settings"
          updateEntity={async (enableDownload) => {
            if (enableDownload) {
              await enable()
            } else {
              await disable()
            }
          }}
        />
      </span>
    </SettingsRow>
  )
}
